module.exports = __webpack_public_path__ + "img/hannah-masterclass-banner.42273ef3.png";